import { render, staticRenderFns } from "./DescriptionColors.vue?vue&type=template&id=191f6ba2&scoped=true&"
import script from "./DescriptionColors.vue?vue&type=script&lang=js&"
export * from "./DescriptionColors.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionColors.vue?vue&type=style&index=0&id=191f6ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191f6ba2",
  null
  
)

export default component.exports